/**
 * Temporarily store a message for the duration of a users 
 * session or until the message is read.
 */
const Flash = {
    /**
     * 
     * @param {string} key 
     * @param {string} value 
     * 
     * @return {Promise<string>}
     */
    set: (key, value) => {
        return new Promise((resolve) => {
            sessionStorage.setItem(key, String(value));

            resolve();
        });
    },

    /**
     * Get value of message and forget it.
     * 
     * @param {string} key 
     * 
     * @return {Promise<string>}
     */
    get: (key) => {
        return new Promise((resolve) => {
            const value = sessionStorage.getItem(key);
            
            Flash.forget(key);

            return resolve(value);
        });
    },

    /**
     * Remove message
     * 
     * @return {Promise<void>}
     */
    forget: (key) => {
        return new Promise((resolve) => {
            sessionStorage.removeItem(key);
            return resolve();
        });
    },
};

export default Flash;
